import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

export default function RequireAuth({ adminOnly = false }) {
  const location = useLocation();
  const token = localStorage.getItem('access_token');
  const { isPartner } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (adminOnly && isPartner) {
    return <Navigate to="/partner/dashboard" replace />;
  }

  return <Outlet />;
}
